// Round 100, D2 — host-based route gating. Firebase Hosting serves the SAME
// built SPA (frontend/dist) to both emi.irtaki.net and admin.irtaki.net (see
// firebase.json's 'app'/'admin' targets) — a single build, one Vite config,
// no risk of the two drifting apart. What differs is which ROUTE TREE App()
// mounts, decided here from window.location.hostname. This is genuine
// route-level isolation, not cosmetic: React Router never even attempts to
// match /admin/* on the learner host (so AdminLayout and every admin page's
// lazy chunk are never requested), and never mounts LearnerLayout/the
// learner route tree on the admin host. The real authorization boundary
// stays the backend's requireAdmin/requireSuperAdmin middleware — this is
// about not SERVING the wrong UI to the wrong host, not a security control
// on its own.
//
// Includes each site's default Firebase domain (<site-id>.web.app /
// .firebaseapp.com) alongside the real custom domain, so admin mode is
// verifiable before the custom-domain DNS/verification (owner-only, Section
// F) is actually live.
const ADMIN_HOSTNAMES = new Set([
  'admin.irtaki.net',
  'irtaki-admin.web.app',
  'irtaki-admin.firebaseapp.com',
  // Round 113 — local development: browsers resolve *.localhost to loopback with no hosts-file edit, so
  // http://admin.localhost:5173 shows the admin tree against the emulators. No production DNS can point here.
  'admin.localhost',
]);

export type HostRole = 'admin' | 'app';

export function getHostRole(): HostRole {
  return ADMIN_HOSTNAMES.has(window.location.hostname) ? 'admin' : 'app';
}
